import type { ThemeConfig } from 'antd'

const themeConfig: ThemeConfig = {
  cssVar: true,
  token: {
    colorPrimary: '#5ef0f0',
    colorInfo: '#5ef0f0',
    borderRadius: 4,
    colorTextBase: '#333333',
    colorText: '#333333',
    colorBorder: '#dddddd',
    colorSplit: '#eeeeee',
  },
  components: {
    Input: {
      colorBorder: '#dddddd',
      activeBorderColor: '#666666',
      hoverBorderColor: '#999999',
      colorPrimaryHover: '#999999',
      colorPrimaryActive: '#999999',
      activeShadow: '0 0 0 2px rgba(240,240,240,0.5)',
    },
    Button: {
      // primaryColor: '#333333',
      // colorPrimaryHover: '#55eded',
      colorLink: '#1EDADB',
      colorLinkHover: '#5ef0f0',
      colorBorder: '#dddddd',
    },
    Slider: {
      colorPrimary: '#1bdee0',
      colorPrimaryHover: '#1bdee0',
      colorPrimaryBorder: '#1bdee0',
      trackHoverBg: '#1bdee0',
      trackBg: '#1bdee0',
      dotBorderColor: '#1bdee0',
      colorBorderBg: '#1bdee0',
    },
    Progress: {
      colorPrimary: '#1bdee0',
      colorPrimaryHover: '#1bdee0',
      colorPrimaryActive: '#1bdee0',
    },
    Pagination: {
      colorPrimary: '#aaaaaa',
      colorPrimaryHover: '#9999999',
      colorPrimaryActive: '#666666',
    },
    Select: {
      colorBorder: '#dddddd',
      hoverBorderColor: '#999999',
      activeBorderColor: '#666666',
      boxShadow: '0 0 0 2px rgba(240,240,240,0.5)',
      boxShadowSecondary: '0 0 0 2px rgba(240,240,240,0.5)',
      boxShadowTertiary: '0 0 0 2px rgba(240,240,240,0.5)',
      activeOutlineColor: '0 0 0 2px rgba(240,240,240,0.2)',
    },
    DatePicker: {
      colorPrimary: '#333333',
      colorPrimaryHover: '#333333',
      colorPrimaryActive: '#333333',
    },
    Dropdown: {
      colorPrimary: '#333333',
    },
  },
}

export default themeConfig
